var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-column hp-10 flex prelative min-h-350",
      class: _vm.classes
    },
    [
      _c("SellsyListing", {
        attrs: {
          enableFiltering: false,
          enableExport: _vm.more.enableExport,
          endpoint: "",
          linkedtype: _vm.more.linkedtype,
          name: _vm.more.name,
          url: _vm.more.url,
          "use-favorites": false,
          prefilter: _vm.prefilter,
          buttons: _vm.buttons,
          "related-permissions": _vm.permissions
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _vm._v("\n            " + _vm._s(_vm.more.title) + "\n        ")
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }